<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-28 19:21:55
 * @LastEditTime: 2022-11-29 12:36:50
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
-->
<template>
    <div class="mask">
        <div class="loading">
            <img src="../../../assets/loading.gif" alt="">
            <span>{{ message }}</span>
        </div>
    </div>
</template>

<script>
let top = 0;
export default {
    props: {
        message: {
            type: String,
            default: () => '发券中，请稍后...'
        }
    },
    data() {
        return {};
    },
    mounted() {
        this.stopScroll(true);
    },
    destroyed() {
        this.stopScroll(false);
    },
    methods: {
        /**
         * 阻止页面滚动，用于弹窗开启
         */
        stopScroll(isFixed) {
            const bodyEl = document.body;
            if (isFixed) {
                top = window.scrollY;
                bodyEl.style.position = 'fixed';
                bodyEl.style.top = -top + 'px';
            }
            else {
                bodyEl.style.position = '';
                bodyEl.style.top = '';

                window.scrollTo(0, top); // 回到原先的top
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.mask{
    width:100vw;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,.68);
    display:flex;
    justify-content: center;
    align-items: center;
    z-index:999;
    .loading{
        display:flex;
        align-items: center;
        justify-content: center;
        img{
            width:25px;
            height:25px
        }
        span{
            font-size:14px;
            color:white;
        }
    }
}
</style>